import { useEffect } from 'react'

import { useSyncedRef } from './useSyncedRef'

export function useTimeout(callback: () => void, delay: number | null): void {
  const syncedCallbackRef = useSyncedRef(callback)

  useEffect(() => {
    // Don't schedule if no delay is specified.
    // Note: 0 is a valid value for delay.
    if (!delay && delay !== 0) return

    const id = setTimeout(() => syncedCallbackRef.current?.(), delay)

    return () => clearTimeout(id)
  }, [delay, syncedCallbackRef])
}
